import { memoize } from "lodash-es";

export const singleLazyInstance = memoize(
  (key: string, cb) => cb(),
  (key) => key
);
